import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const QuoteViewContainer = styled.section`
  padding: 20px 0px;
`;

export const BannerContainer = styled.section`
  background-color: #fff;
  bottom: 0;
  box-shadow: 0 -2px 4px 0 hsla(0, 0%, 46%, 0.25);
  left: 0;
  text-align: right;
  position: fixed;
  right: 0;
  width: 100%;
`;

export const ValidationWrapper = styled.div`
  margin: 0 auto;
  max-width: 75rem;
`;
export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
`;
